import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=1c386a5a&scoped=true&"
import script from "./plan.vue?vue&type=script&lang=ts&"
export * from "./plan.vue?vue&type=script&lang=ts&"
import style0 from "./plan.vue?vue&type=style&index=0&id=1c386a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c386a5a",
  null
  
)

export default component.exports